import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetBudgetItemsForStageById = createAsyncThunk(
  "GetBudgetItemsForStageById/GetBudgetItemsForStageById",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItemsForStage/GetBudgetItemsForStageById",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteBudgetItemsForStage = createAsyncThunk(
  "DeleteBudgetItemsForStage/DeleteBudgetItemsForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItemsForStage/DeleteBudgetItemsForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateBudgetItemsForStage = createAsyncThunk(
  "UpdateBudgetItemsForStage/UpdateBudgetItemsForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItemsForStage/UpdateBudgetItemsForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidationBudgetItemsForStage = createAsyncThunk(
  "UpdateBudgetItemsForStage/ValidationBudgetItemsForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BudgetItemsForStage/ValidationBudgetItemsForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const BudgetItemsForStage = createSlice({
  name: "BudgetItemsForStage",
  initialState: {
    BudgetItemsForStage: {},
    loadingBudgetItemsForStage: false,
    errorBudgetItemsForStage: null,

    UpdateBudgetItemsForStage: {},
    loadingUpdateBudgetItemsForStage: false,
    errorUpdateBudgetItemsForStage: null,

    DeleteBudgetItemsForStage: {},
    loadingDeleteBudgetItemsForStage: false,
    errorDeleteBudgetItemsForStage: null,

    ValidationBudgetItemsForStage: {},
    loadingValidationBudgetItemsForStage: false,
    errorValidationBudgetItemsForStage: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetBudgetItemsForStageById.pending, (state, action) => {
        state.loadingBudgetItemsForStage = true;
        state.BudgetItemsForStage = action.payload;
        state.errorBudgetItemsForStage = null;
      })
      .addCase(GetBudgetItemsForStageById.fulfilled, (state, action) => {
        state.loadingBudgetItemsForStage = false;
        state.BudgetItemsForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetBudgetItemsForStageById.rejected, (state, action) => {
        state.loadingBudgetItemsForStage = false;
        state.errorBudgetItemsForStage = action.payload;
      })

      .addCase(DeleteBudgetItemsForStage.pending, (state, action) => {
        state.loadingDeleteBudgetItemsForStage = true;
        state.DeleteBudgetItemsForStage = action.payload;
        state.errorDeleteBudgetItemsForStage = null;
      })
      .addCase(DeleteBudgetItemsForStage.fulfilled, (state, action) => {
        state.loadingDeleteBudgetItemsForStage = false;
        state.BudgetItemsForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteBudgetItemsForStage.rejected, (state, action) => {
        state.loadingDeleteBudgetItemsForStage = false;
        state.errorDeleteBudgetItemsForStage = action.payload;
      })

      .addCase(UpdateBudgetItemsForStage.pending, (state, action) => {
        state.loadingUpdateBudgetItemsForStage = true;
        state.UpdateBudgetItemsForStage = action.payload;
        state.errorUpdateBudgetItemsForStage = null;
      })
      .addCase(UpdateBudgetItemsForStage.fulfilled, (state, action) => {
        state.loadingUpdateBudgetItemsForStage = false;
        state.UpdateBudgetItemsForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateBudgetItemsForStage.rejected, (state, action) => {
        state.loadingUpdateBudgetItemsForStage = false;
        state.errorUpdateBudgetItemsForStage = action.payload;
      })


      .addCase(ValidationBudgetItemsForStage.pending, (state, action) => {
        state.loadingValidationBudgetItemsForStage = true;
        state.ValidationBudgetItemsForStage = action.payload;
        state.errorValidationBudgetItemsForStage = null;
      })
      .addCase(ValidationBudgetItemsForStage.fulfilled, (state, action) => {
        state.loadingValidationBudgetItemsForStage = false;
        state.ValidationBudgetItemsForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidationBudgetItemsForStage.rejected, (state, action) => {
        state.loadingValidationBudgetItemsForStage = false;
        state.errorValidationBudgetItemsForStage = action.payload;
      });
  },
});

export default BudgetItemsForStage.reducer;
